import { render, staticRenderFns } from "./discountSummary.vue?vue&type=template&id=55b4f500&scoped=true"
import script from "./discountSummary.vue?vue&type=script&lang=js"
export * from "./discountSummary.vue?vue&type=script&lang=js"
import style0 from "./discountSummary.vue?vue&type=style&index=0&id=55b4f500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4f500",
  null
  
)

export default component.exports